import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer4GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Горплей"
        attackSignal="gorplay_attack"
        healSignal="gorplay_heal"
        attackDescription="Кости по очереди появляются из пола слева направо. Урон 5."
        healDescription="Большая кость летит сверху вниз. Лечение 10."
    />
);
